import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">

<path d="M4652 7238 c-146 -16 -273 -115 -335 -261 -22 -52 -22 -53 -25 -797
-4 -801 -2 -837 46 -925 l28 -50 73 2 c164 5 520 79 736 153 180 62 440 197
452 235 2 6 -45 26 -105 47 -300 102 -562 275 -676 447 -66 98 -88 161 -94
267 -9 164 51 296 195 435 149 143 354 256 633 350 80 27 147 49 150 50 3 0
-26 10 -65 22 -65 19 -104 21 -510 26 -242 3 -469 3 -503 -1z"/>
<path d="M5950 7003 c-130 -30 -313 -84 -403 -119 -178 -70 -412 -206 -376
-218 8 -3 65 -23 126 -45 377 -133 648 -348 729 -578 9 -26 19 -84 21 -128 10
-158 -45 -284 -186 -426 -175 -176 -440 -310 -809 -409 -80 -22 -154 -40 -164
-40 -9 0 -19 -3 -21 -7 -3 -5 144 -7 326 -5 253 1 351 6 412 18 375 73 676
320 823 676 96 231 106 518 26 756 -61 182 -178 363 -311 479 -81 70 -86 71
-193 46z"/>
<path d="M4992 6453 c-4 -10 -7 -45 -6 -78 1 -143 143 -295 391 -419 164 -82
408 -165 427 -146 6 6 11 41 11 78 0 51 -6 79 -25 116 -63 124 -224 251 -445
348 -82 36 -316 118 -337 118 -5 0 -12 -8 -16 -17z"/>
<path d="M3590 4416 c0 -226 4 -365 11 -383 30 -82 125 -126 223 -104 78 18
78 17 63 92 -10 46 -18 63 -28 61 -36 -9 -81 -5 -90 8 -5 9 -9 163 -9 348 l0
332 -85 0 -85 0 0 -354z"/>
<path d="M4900 4355 l0 -415 85 0 85 0 0 43 c0 36 7 50 43 92 l43 48 70 -91
69 -91 108 -1 108 0 -120 157 -120 158 27 30 c16 16 61 67 101 113 l74 83
-103 -3 -103 -3 -91 -101 c-50 -56 -94 -102 -98 -103 -5 -1 -8 112 -8 249 l0
250 -85 0 -85 0 0 -415z"/>
<path d="M4014 4730 c-31 -12 -54 -49 -54 -88 0 -47 16 -71 57 -88 66 -28 133
14 133 84 0 44 -14 68 -50 87 -32 17 -54 18 -86 5z"/>
<path d="M3101 4669 c-145 -25 -228 -137 -200 -270 20 -91 83 -134 259 -174
62 -14 114 -25 116 -25 2 0 11 -11 20 -25 14 -21 14 -30 5 -54 -32 -76 -183
-67 -227 15 -23 42 -25 42 -171 9 -50 -12 -5 -112 74 -164 64 -43 112 -55 219
-55 83 0 97 3 158 33 52 26 74 43 96 77 53 83 48 181 -12 250 -42 48 -68 60
-210 93 -80 19 -126 35 -135 47 -37 51 8 104 89 104 43 0 55 -5 82 -32 18 -18
35 -39 38 -47 4 -13 15 -13 79 -2 103 18 102 18 75 77 -53 113 -196 171 -355
143z"/>
<path d="M5570 4300 l0 -360 178 0 c249 0 332 25 422 127 55 63 80 135 80 233
0 101 -26 172 -86 239 -86 96 -172 121 -416 121 l-178 0 0 -360z m350 199
c115 -26 182 -141 150 -258 -26 -98 -115 -151 -252 -151 l-68 0 0 210 0 210
63 0 c34 0 82 -5 107 -11z"/>
<path d="M6999 4648 c0 -7 -1 -47 -2 -88 l-2 -75 -47 -3 -48 -3 0 -70 0 -69
50 0 50 0 -1 -135 c0 -120 2 -141 21 -181 33 -66 93 -99 185 -98 48 0 83 6
111 20 l41 19 -19 62 -18 61 -58 -5 c-86 -8 -92 1 -92 143 l0 114 75 0 c41 0
75 3 75 8 1 4 3 24 6 45 3 21 3 49 0 63 -6 23 -10 24 -81 24 -53 0 -75 4 -75
13 -1 6 -2 46 -3 87 l-2 75 -82 3 c-62 2 -83 0 -84 -10z"/>
<path d="M4479 4490 c-147 -25 -248 -156 -237 -305 13 -156 126 -257 288 -259
90 -1 158 25 213 82 36 37 73 109 62 120 -3 4 -37 14 -75 23 l-70 16 -20 -34
c-42 -72 -144 -81 -200 -17 -26 30 -30 42 -30 95 0 56 3 64 34 95 58 58 159
46 191 -22 11 -24 21 -33 33 -30 9 2 43 10 75 17 32 7 60 16 63 20 9 16 -46
107 -83 138 -60 50 -161 75 -244 61z"/>
<path d="M7640 4493 c-88 -14 -157 -58 -189 -120 -21 -41 -14 -49 53 -61 82
-15 96 -15 96 2 0 23 41 46 80 46 42 0 80 -33 80 -68 0 -21 -4 -22 -108 -22
-95 0 -114 -3 -158 -25 -111 -55 -128 -205 -32 -278 66 -50 205 -57 264 -12
25 19 34 19 34 0 0 -13 14 -15 83 -13 l82 3 3 165 c3 211 -6 261 -62 316 -50
50 -149 79 -226 67z m116 -365 c-7 -38 -38 -65 -83 -74 -72 -14 -129 41 -88
86 15 17 30 20 98 20 l80 0 -7 -32z"/>
<path d="M6497 4480 c-59 -18 -137 -98 -137 -141 0 -22 151 -50 158 -29 25 74
162 61 162 -15 0 -25 -1 -25 -97 -25 -115 0 -161 -11 -204 -47 -80 -67 -78
-194 2 -256 68 -52 173 -58 255 -17 46 24 44 24 44 5 0 -12 16 -15 86 -15 l85
0 -3 203 c-3 199 -3 203 -30 249 -41 68 -106 98 -212 97 -45 0 -94 -5 -109 -9z
m183 -345 c0 -31 -40 -71 -81 -80 -75 -17 -129 28 -95 80 15 23 22 25 96 25
79 0 80 0 80 -25z"/>
<path d="M3970 4210 l0 -270 85 0 85 0 0 270 0 270 -85 0 -85 0 0 -270z"/>
<path d="M3907 3762 c-10 -10 -17 -26 -17 -35 0 -9 -4 -17 -10 -17 -5 0 -10
-7 -10 -15 0 -8 5 -15 10 -15 6 0 10 -27 10 -60 0 -47 3 -60 15 -60 12 0 15
13 15 60 l0 60 35 0 35 0 0 -60 c0 -47 3 -60 15 -60 12 0 15 13 15 60 0 57 1
60 25 60 16 0 25 6 25 15 0 9 -10 15 -26 15 -33 0 -30 33 4 38 27 4 29 32 2
32 -23 0 -60 -33 -60 -55 0 -10 -11 -15 -35 -15 -42 0 -48 25 -9 40 14 6 22
14 19 20 -10 16 -40 12 -58 -8z"/>
<path d="M6168 3769 c-10 -5 -18 -21 -18 -34 0 -16 -6 -25 -15 -25 -8 0 -15
-7 -15 -15 0 -8 7 -15 15 -15 12 0 15 -13 15 -60 0 -47 3 -60 15 -60 12 0 15
13 15 60 l0 60 35 0 35 0 0 -60 c0 -47 3 -60 15 -60 12 0 15 13 15 60 l0 60
35 0 35 0 0 -60 c0 -47 3 -60 15 -60 12 0 15 15 15 75 l0 75 -51 0 c-43 0 -50
3 -47 18 2 9 14 18 26 20 26 4 25 25 -2 30 -22 5 -56 -25 -56 -50 0 -14 -8
-18 -35 -18 -28 0 -35 4 -35 20 0 13 7 20 20 20 11 0 20 7 20 15 0 17 -27 19
-52 4z"/>
<path d="M4510 3730 c0 -38 -1 -39 -24 -29 -54 25 -115 -28 -100 -86 9 -35 52
-67 78 -59 12 4 33 7 48 6 l28 -1 0 105 c0 86 -3 104 -15 104 -11 0 -15 -11
-15 -40z m-7 -71 c14 -23 1 -67 -23 -74 -23 -7 -55 8 -64 30 -3 8 -1 27 4 41
8 21 15 25 41 22 18 -2 36 -10 42 -19z"/>
<path d="M4780 3664 c0 -103 1 -106 21 -101 12 3 32 1 46 -4 28 -10 77 10 87
36 24 65 -20 121 -86 111 -38 -6 -38 -6 -38 29 0 24 -5 35 -15 35 -12 0 -15
-18 -15 -106z m123 -5 c14 -23 1 -67 -23 -74 -23 -7 -55 8 -64 30 -3 8 -1 27
4 41 8 21 15 25 41 22 18 -2 36 -10 42 -19z"/>
<path d="M4980 3665 c0 -87 3 -105 15 -105 12 0 15 18 15 105 0 87 -3 105 -15
105 -12 0 -15 -18 -15 -105z"/>
<path d="M5800 3735 c0 -35 0 -35 -38 -29 -51 8 -92 -23 -92 -71 0 -47 27 -76
70 -75 19 0 47 1 63 1 l27 0 0 104 c0 87 -3 105 -15 105 -10 0 -15 -11 -15
-35z m-24 -63 c33 -22 13 -92 -26 -92 -40 0 -66 60 -38 88 13 13 47 16 64 4z"/>
<path d="M6350 3756 c0 -21 21 -31 30 -15 5 7 6 17 4 21 -9 14 -34 9 -34 -6z"/>
<path d="M6604 3759 c-8 -14 18 -31 30 -19 9 9 0 30 -14 30 -5 0 -12 -5 -16
-11z"/>
<path d="M3706 3674 c-52 -119 -50 -114 -32 -114 9 0 21 11 26 26 9 23 14 25
57 22 39 -2 50 -7 58 -25 5 -13 18 -23 27 -23 16 0 16 3 -1 43 -56 129 -71
157 -84 157 -8 0 -30 -37 -51 -86z m74 -4 c15 -37 11 -42 -28 -38 l-30 3 15
37 c17 42 25 42 43 -2z"/>
<path d="M5950 3660 l0 -100 75 0 c60 0 75 3 75 15 0 12 -13 15 -61 15 -60 0
-60 0 -57 27 3 25 6 27 52 27 30 1 51 6 53 14 3 9 -11 12 -51 12 -56 0 -56 0
-56 30 l0 30 60 0 c47 0 60 3 60 15 0 12 -15 15 -75 15 l-75 0 0 -100z"/>
<path d="M7060 3731 c0 -10 -9 -21 -20 -24 -26 -7 -26 -27 0 -27 16 0 19 -8
22 -57 3 -52 5 -58 28 -63 31 -8 50 -2 50 16 0 8 -9 13 -22 11 -21 -2 -23 3
-26 46 -3 45 -2 47 23 47 31 0 29 23 -2 28 -12 2 -23 12 -26 23 -7 24 -27 25
-27 0z"/>
<path d="M4105 3685 c-27 -26 -31 -54 -14 -88 16 -30 28 -37 69 -37 19 0 40 4
46 8 16 11 34 48 34 72 0 32 -44 70 -80 70 -19 0 -40 -9 -55 -25z m99 -37 c8
-22 6 -32 -9 -48 -22 -24 -42 -25 -67 -3 -38 34 -15 86 37 81 22 -2 32 -10 39
-30z"/>
<path d="M4279 3708 c0 -2 -2 -36 -4 -75 -2 -58 0 -73 11 -73 8 0 14 8 14 18
0 46 21 92 45 98 14 3 25 12 25 20 0 17 -14 18 -43 3 -16 -9 -22 -9 -25 0 -3
9 -20 16 -23 9z"/>
<path d="M4602 3687 c-42 -45 -16 -129 38 -128 14 0 40 1 58 1 l32 1 0 72 0
72 -53 2 c-45 2 -57 -1 -75 -20z m86 -19 c7 -7 12 -25 12 -40 0 -34 -41 -59
-68 -41 -21 12 -28 59 -11 79 14 17 51 18 67 2z"/>
<path d="M5073 3695 c-39 -27 -38 -101 1 -127 22 -15 83 -8 100 11 14 16 15
19 2 24 -8 3 -20 -1 -26 -9 -17 -19 -44 -18 -63 4 -23 25 -13 32 50 32 46 0
53 3 53 19 0 24 -45 61 -74 61 -12 0 -31 -7 -43 -15z m81 -30 c4 -12 -3 -15
-34 -15 -38 0 -49 8 -33 23 12 13 61 7 67 -8z"/>
<path d="M5314 3685 c-25 -25 -31 -63 -14 -95 13 -24 67 -42 89 -30 10 5 28 6
40 3 21 -5 22 -4 19 67 l-3 74 -53 3 c-45 2 -57 -1 -78 -22z m98 -30 c9 -19 8
-29 -6 -50 -18 -27 -36 -31 -67 -15 -22 12 -26 59 -7 78 22 22 67 14 80 -13z"/>
<path d="M5499 3695 c-3 -38 0 -128 5 -132 13 -13 24 11 24 52 0 54 6 65 37
65 30 0 45 -26 45 -79 0 -31 4 -41 16 -41 24 0 15 117 -11 136 -20 15 -115 14
-116 -1z"/>
<path d="M6445 3685 c-43 -42 -30 -104 25 -124 37 -12 74 -1 90 29 13 25 -5
28 -31 4 -40 -36 -101 19 -72 65 13 21 57 26 72 7 7 -8 19 -12 27 -9 12 5 11
10 -7 29 -30 32 -73 31 -104 -1z"/>
<path d="M6610 3636 c0 -62 3 -76 15 -76 13 0 15 12 13 72 -2 46 -7 73 -15 76
-10 3 -13 -16 -13 -72z"/>
<path d="M6702 3690 c-28 -26 -30 -90 -4 -113 31 -28 104 -23 116 8 7 18 2 18
-40 3 -26 -9 -36 -9 -48 1 -25 21 -19 40 12 39 74 -1 82 1 82 26 0 51 -77 74
-118 36z m86 -27 c2 -9 -9 -13 -37 -13 -39 0 -50 8 -34 24 11 11 66 2 71 -11z"/>
<path d="M6860 3635 c0 -60 3 -75 15 -75 11 0 15 11 15 43 0 54 18 80 51 75
22 -3 24 -8 27 -60 2 -43 7 -58 17 -58 24 0 21 112 -3 133 -21 19 -45 21 -73
7 -13 -7 -19 -7 -19 0 0 5 -7 10 -15 10 -12 0 -15 -15 -15 -75z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
